export function filterStartTag(oriWord) {
  let toFilter = oriWord;
  if (toFilter.startsWith('##')) {
    toFilter = toFilter.replace('##', '');
  } else if (toFilter.startsWith('#')) {
    toFilter = toFilter.replace('#', '');
  }
  return toFilter;
}
